import storage from 'utils/storage'
import { ACCESS_TOKEN } from 'utils/constant'

const set = function (token) {
  if (typeof token !== 'undefined') {
    storage.set(ACCESS_TOKEN, token, 3600 * 24 * 3)
    return token
  }
}

const get = function () {
  return storage.get(ACCESS_TOKEN)
}

const clean = function () {
  storage.remove(ACCESS_TOKEN)
}

export default {get, set, clean}



// WEBPACK FOOTER //
// ./src/common/utils/access-token.js